import script from "./AmButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AmButton.vue?vue&type=script&setup=true&lang=js"

import "./AmButton.vue?vue&type=style&index=0&id=5ed9dae0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed9dae0"]])

export default __exports__